export default __webpack_public_path__ + "static/media/coinplus.ee934493.svg";